// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6 from "../../randing/RandingStyle6";

function Randing095({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/095/25021201.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/095/25021202.gif`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/095/25021203.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="blue"
      questionType="btn"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costBenefitButton3.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing095;
